// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__L0x8q"};